export default "__VITE_ASSET__DCt6Snc9__"